import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Campus } from 'src/app/models/campus.model';
import { Poll } from 'src/app/models/poll.model';
import { School } from 'src/app/models/school.model';
import { EscolarService } from 'src/app/services/escolar.service';
import { SecureStorageService } from 'src/app/services/secure-storage.service';
import { IconsService } from 'src/app/shared/services/icons.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-create-poll',
  template: `
    <div class="bg-white p-4 rounded-4 shadow">
      <div class="d-flex mb-4">
        <img [src]="environment.ESCALAS_WSPREFIX + (school?.logo?.url || '')" width="18" height="18" class="ms-2" *ngIf="school?.logo">
        <fa-icon [icon]="icons.faChevronRight" class="mx-2" style="font-size: 0.7em; margin-top: 2px;"></fa-icon>
        <xng-breadcrumb></xng-breadcrumb>
      </div>
      <div class="d-flex mb-2">
        <div class="flex-fill">
          <div class="flex-column">
            <h4 class="mb-0 mt-2">Votación</h4>
            <p>Configura la información de la votación.</p>
          </div>
          <div class="flex-column">
            <app-form-poll
              (taskData)="createPoll($event)"
              [poll]="poll"
              [loading]="loading"
              [school]="school"
              [campuses]="campuses"
            ></app-form-poll>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: ``
})
export class CreatePollComponent implements OnInit {
  environment = environment;
  poll: Poll | null = null;
  permissions: any = {};
  campuses: Campus[] = [];
  school: School | null = null;
  loading: boolean = false;

  payload: any = {
    page: 1,
    per_per: 100,
    role_id: 3,
  };

  constructor(
    private readonly escolarService: EscolarService,
    private readonly router: Router,
    private readonly toastr: ToastrService,
    private readonly breadcrumbService: BreadcrumbService,
    public icons: IconsService,
    private readonly secureStorage: SecureStorageService
  ) {}

  ngOnInit(): void {
    this.loadStoredData();
  }

  private async loadStoredData() {
    try {
      this.permissions = await this.secureStorage.getObject('permissions') || {};
      const schoolData = await this.secureStorage.getItem('school');
      this.school = schoolData ? JSON.parse(schoolData) : null;
      this.campuses = await this.secureStorage.getObject<Campus[]>('campuses') || [];
      
      console.log('CreatePollComponent - Data loaded:', { school: this.school, campuses: this.campuses.length });
    } catch (error) {
      console.error('CreatePollComponent - Error loading data:', error);
      this.campuses = [];
      this.school = null;
      this.permissions = {};
    }
  }

  createPoll(event: any) {}

}
